// Import jQuery
import $ from 'jquery';

window.$ = $;

// Require Foundation modules
import './modules/AjaxPosts';
import './modules/MegaMenu';
import './modules/Newsletter';
import './modules/Search';
import './modules/SmoothScroll';
import './modules/ViewSwitch';
import './modules/Splide';
import 'foundation-sites/dist/js/plugins/foundation.tabs.min.js';



// IE fix

    import './modules/ObjectFitIE';
    
 


// -------------Uncomment if needed----------------------//
// -----------------------------------------------------//

// import 'foundation-sites/dist/js/plugins/foundation.core.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.touch.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.motion.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.util.imageLoader.min.js'; // Uncomment if needed
import 'foundation-sites/dist/js/plugins/foundation.reveal.min.js';
import 'foundation-sites/dist/js/plugins/foundation.accordion.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.accordionMenu.min.js';
// import 'foundation-sites/dist/js/plugins/foundation.tooltip.min.js';
 import 'foundation-sites/dist/js/plugins/foundation.offcanvas.min.js';
import 'foundation-sites/dist/js/plugins/foundation.drilldown.min.js';
import 'foundation-sites/dist/js/plugins/foundation.sticky.min.js';
import 'foundation-sites/dist/js/plugins/foundation.dropdownMenu.min.js';
import 'foundation-sites/dist/js/plugins/foundation.dropdown.min.js';
// Import custom modules
// import './modules/Animation';
// import './modules/ExternalLinks';
//import './modules/Tabs';

import { initSelectServices } from './modules/SelectServices';
import { initMobileMenu } from './modules/MobileMenu';
 // Initialize Foundation
document.addEventListener('DOMContentLoaded', function () {

    initSelectServices();
    $(document).foundation();
    initMobileMenu();
  // Initialize Foundation JavaScript components
  // This must be called AFTER jQuery and Foundation are loaded on the page.
        // Get the off-canvas element
        const offCanvas = document.getElementById('offCanvas');

        if (!offCanvas) {
            return;
        }
        
        // Create a MutationObserver to watch for class changes
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    const isOpen = offCanvas.classList.contains('is-open');
                    if (isOpen) {
                        document.documentElement.classList.add('is-off-canvas-open');
                    } else {
                        document.documentElement.classList.remove('is-off-canvas-open');
                    }
                }
            });
        });
        
        // Start observing the off-canvas element for class changes
        observer.observe(offCanvas, {
            attributes: true,
            attributeFilter: ['class']
        });
        
        // Also handle initial state
        if (offCanvas.classList.contains('is-open')) {
            document.documentElement.classList.add('is-off-canvas-open');
        }
});

import SearchPeople from './modules/SearchPeople'; // ✅ Adjust the path as needed

function initSearchPeople() {
    if (!document.querySelector('.search-people__input')) return;
    new SearchPeople();
}

window.addEventListener('DOMContentLoaded', initSearchPeople);
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        initSearchPeople();
    }
});
